import { useConfigContext } from '@fe-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enroll } from '@api/queries/session';
import { QUERY_KEY } from '@hooks/data/useSessionDetails';

export const useSessionEnrollment = ({ sessionId }: { sessionId: number }) => {
  const { config } = useConfigContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      enroll({ baseUrl: config.apiUrls.ccapi as string, sessionId }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY],
      });
    },
  });
};
